import _ from 'underscore';

class EventPromoterLinksCtrl {
  constructor($scope, $q, organizationService, alertService, sdkUtils, sdkEventService, urlService, $timeout, $stateParams, mapperService, attributionSourceService, managementUserService, documentDownloadService, venueService, permissionService, modalService) { //eslint-disable-line
    const _this = this;

    this._$scope = $scope;
    this._$q = $q;
    this._organizationService = organizationService;
    this._currentUser = managementUserService.getCurrentUser();
    this._currentUserOrganization = this._organizationService.getCurrentOrganization();
    this._alertService = alertService;
    this._sdkUtils = sdkUtils;
    this._sdkEventService = sdkEventService;
    this._urlService = urlService;
    this._$timeout = $timeout;
    this._$stateParams = $stateParams;
    this._mapperService = mapperService;
    this._attributionSourceService = attributionSourceService;
    this._venueService = venueService;
    this._permissionService = permissionService;

    this._$scope.venueId = this._$stateParams.venueId;

    this._$scope.isExternalOrganization = function () {
      return _this._$scope.venue ? _this._permissionService.isExternalOrganization(_this._$scope.venue.organization) : false;
    };

    this._$scope.loading = true;
    this._$scope.eventForm = {};

    this._$scope.linkCopied = function (relationship, $event) {
      if (!relationship) return;
      if ($event) $event.preventDefault();

      relationship.showCopiedTooltip = true;
    };

    this._$scope.downloadLinks = function ($event) {
      if ($event) $event.preventDefault();

      alertService.success('Download started...');

      documentDownloadService.downloadExcel(documentDownloadService.TEMPLATES.ATTRIBUTION_SOURCE_EXPORT, {
        attributionSources: _.filter(_this._$scope.attributionSources, attr => {
          return attr.type === 'MEMBER' || attr.type === 'RELATIONSHIP' || attr.type === 'CUSTOM';
        }).map(attr => {
          if (attr.type === 'MEMBER') attr.type = 'Staff Member';
          if (attr.type === 'RELATIONSHIP') attr.type = 'Promoter';
          if (attr.type === 'CUSTOM') attr.type = 'Custom';
          return attr;
        })
      }, 'Nightpro-Staff-and-Promoter-Links');
    };

    this._$scope.showAttributionLinksEmailModal = function ($event) {
      if ($event) $event.preventDefault();

      modalService.attributionLinksEmail({
          event: _this._$scope.event,
          attributionSources: _this._$scope.attributionSources
        })
        .then(() => {});
    };

    this._$q.all([
        this._getAttributionSources(),
        this._getCurrentUserAttributionSource(),
        $scope.venuePromise,
        $scope.eventPromise
      ])
      .then(results => {
        this._$scope.attributionSources = results[0];
        this._$scope.currentUserAttributionSource = results[1];
        this._$scope.venue = results[2];
        this._$scope.event = mapperService.mapEventToUI(results[3]);

        if (!this._$scope.event) {
          this.noEvent = true;
          return;
        }

        this._$scope.eventForm.event = this._$scope.event;

        const seoPathname = this._$scope.event.seoPathname || this._$scope.event.id;

        _this._generateAttributionSourceLinksByEventId(seoPathname, this._$stateParams.venueId);
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)))
      .finally(() => {
        this._$scope.loading = false;
      });
  }

  _getAttributionSources() {
    return this._attributionSourceService.listByOrganizationId(this._currentUserOrganization.id)
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  _clearPromoterLinks() {
    this._$scope.relationships.forEach(relationship => {
      delete relationship.link;
    });
  }

  _getVenue(venueId) {
    if (!venueId) throw new Error('_getVenue() - venueId is required');

    return this._venueService.readById(venueId, {
        fields: [
          'name',
          'id',
          'organization'
        ].join(',')
      })
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  _generateAttributionSourceLinksByEventId(seoPathname, venueId) {
    if (!seoPathname) throw new Error('_generatePromoterLinksByEventId() - seoPathname is required');
    if (!venueId) throw new Error('_generatePromoterLinksByEventId() - venueId is required');

    this._$scope.attributionSources.forEach(attributionSource => {
      attributionSource.link = this._urlService.getEventPublicPageUrl(seoPathname, {
        venue: venueId,
        attributionId: attributionSource.id
      });
    });

    this._$scope.currentUserAttributionSource.link = this._urlService.getEventPublicPageUrl(seoPathname, {
      venue: venueId,
      attributionId: this._$scope.currentUserAttributionSource.id
    });

    this._$scope.currentUserAttributionSource.currentUser = true;

    this._$scope.currentUserAttributionSource.name = (this._currentUser.firstName && this._currentUser.lastName) ? `${this._currentUser.firstName} ${this._currentUser.lastName}` : this._currentUser.email; //eslint-disable-line

    this._$scope.members = _.where(this._$scope.attributionSources, {
      type: 'MEMBER'
    });

    this._$scope.members = _.reject(this._$scope.members, member => {
      return member.id === this._$scope.currentUserAttributionSource.id;
    });

    this._$scope.relationships = _.where(this._$scope.attributionSources, {
      type: 'RELATIONSHIP'
    });

    this._$scope.customSources = _.where(this._$scope.attributionSources, {
      type: 'CUSTOM'
    });
  }

  /**
   * @return {Promise}
   */
  _getEventById(id) {
    if (!id) return this._$q.reject(new Error('id is required'));

    return this._sdkEventService.readById(id)
      .then(this._mapperService.mapEventToUI)
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  _getCurrentUserAttributionSource() {
    return this._attributionSourceService.listByManagementUserId(this._currentUser.id, {
        organizationId: this._currentUserOrganization.id
      })
      .then(attributionSources => attributionSources[0])
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }
}

EventPromoterLinksCtrl.$inject = [
  '$scope',
  '$q',
  'organizationService',
  'alertService',
  'jsSdk.utils',
  'jsSdk.event',
  'urlService',
  '$timeout',
  '$stateParams',
  'mapperService',
  'jsSdk.attributionSource',
  'jsSdk.managementUser',
  'documentDownloadService',
  'jsSdk.venue',
  'permissionService',
  'modalService'
];

export default EventPromoterLinksCtrl;



// WEBPACK FOOTER //
// ./src/components/eventPromoterLinks/eventPromoterLinksCtrl.js